document.addEventListener("DOMContentLoaded", function () {
  const AnnouncementBarUtils = {
    init: () => {
      const announcementBar = document.querySelector(
        ".announcement-bar-section"
      );
      if (!announcementBar) {
        return;
      }
      const mainContent = document.querySelector("#MainContent");
      if (!mainContent) {
        return;
      }
      if (mainContent.hasAttribute("style")) {
        //
      } else {
        mainContent.setAttribute(
          "style",
          `--announcement-bar-height: ${announcementBar.clientHeight}px;`
        );
      }
    },
  };

  AnnouncementBarUtils.init();
});

window.addEventListener('load', function () {
  const SignUpDialog = {
    events: () => {
      if (!sessionStorage.getItem("isVisited")) {
        const signupDialog = document.querySelector("#signUpFormPopup");
        if (!signupDialog) return; // either customer is logged in or sign-up form not loaded

        setTimeout(() => {
          signupDialog.open();
          sessionStorage.setItem("isVisited", "true");
        }, 3000);
      }
    },

    init: () => {
      SignUpDialog.events();
    },
  };

  const DiscountClaimedDialog = {
    events: () => {
      if (!localStorage.getItem('discountClaimed')) {
        const discountClaimedDialog = document.querySelector('#popupDiscountClaimed');
        if (!discountClaimedDialog) return;

        setTimeout(() => {
          discountClaimedDialog.open();
          localStorage.setItem('discountClaimed', 'true');
        }, 3000);
      }
    },

    init: () => {
      DiscountClaimedDialog.events();
    },
  };
  
  SignUpDialog.init();
  DiscountClaimedDialog.init();
});